import React from "react";
import { Axis, Orientation } from "@vx/axis";

const TimeAxes = props => {
  const { xScale, height } = props;
  // Hoist this out into AxisConfiguration object
  const num_x_ticks = 12;

  return (
    <>
      <Axis
        scale={xScale}
        orientation={Orientation.top}
        numTicks={num_x_ticks}
      />
      <Axis
        scale={xScale}
        top={height}
        orientation={Orientation.bottom}
        numTicks={num_x_ticks}
      />
    </>
  );
};

export default TimeAxes;
